import React from 'react';
import {Link,useLocation} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLock,FiShield,FiArrowRight,FiCheckCircle,FiAward}=FiIcons;

export default function Footer() {
  const location=useLocation();
  const hiddenPaths=[
    '/weightcart',
    '/haircart',
    '/mencart',
    '/mycart',
    '/admin',
    '/weightquiz',
    '/menquiz',
    '/hairquiz',
    '/quiz'
  ];

  if (hiddenPaths.includes(location.pathname)) return null;

  return (
    <footer className="border-t border-slate-900 bg-slate-950 pb-12 pt-24 text-slate-400">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 flex flex-col items-center justify-between gap-6 rounded-2xl border border-slate-800 bg-slate-900 p-8 md:flex-row">
          <div className="text-lg font-bold text-white">Verified &amp;Accredited Healthcare</div>
          <div className="flex flex-wrap items-center gap-6 text-sm font-medium">
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiAward} className="h-5 w-5 text-teal-500" />
              LegitScript Certified
            </div>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiCheckCircle} className="h-5 w-5 text-teal-500" />
              FDA Registered Pharmacies
            </div>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiShield} className="h-5 w-5 text-teal-500" />
              HIPAA Compliant
            </div>
          </div>
        </div>

        <div className="mb-20 grid grid-cols-2 gap-12 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-2">
            <div className="mb-6 flex items-center gap-2 text-3xl font-extrabold tracking-tighter text-white">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-teal-700 text-lg text-white">R</div>
              RenewRX
            </div>
            <p className="mb-8 max-w-sm text-base leading-relaxed text-slate-400">
              Start your journey to better health today. Premium medical care, delivered directly to your door. No insurance needed.
            </p>
            <Link to="/mytreatments" className="flex w-max items-center gap-2 rounded-full bg-white/10 px-6 py-3 font-semibold text-white transition-all hover:bg-white/20">
              Explore Treatments
              <SafeIcon icon={FiArrowRight} />
            </Link>
          </div>

          <div>
            <h4 className="mb-6 text-xs font-bold uppercase tracking-wide text-white">Services</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/weightrx" className="transition-colors hover:text-teal-400">Weight Loss</Link></li>
              <li><Link to="/menrx" className="transition-colors hover:text-teal-400">Men&apos;s Health</Link></li>
              <li><Link to="/hairrx" className="transition-colors hover:text-teal-400">Hair Loss</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-6 text-xs font-bold uppercase tracking-wide text-white">Company</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/about" className="transition-colors hover:text-teal-400">About Us</Link></li>
              <li><Link to="/faq" className="transition-colors hover:text-teal-400">FAQ</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-teal-400">Contact</Link></li>
              <li><a href="https://patient.leguprecovery.com/login" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-teal-400">Patient Portal</a></li>
              <li><a href="https://patient.leguprecovery.com/login" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-teal-400">Log In</a></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-6 text-xs font-bold uppercase tracking-wide text-white">Legal</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/disclaimer" className="transition-colors hover:text-teal-400">Medical Disclaimer</Link></li>
              <li><Link to="/terms" className="transition-colors hover:text-teal-400">Terms &amp;Conditions</Link></li>
              <li><Link to="/privacy" className="transition-colors hover:text-teal-400">Privacy Policy</Link></li>
              <li><Link to="/shipping" className="transition-colors hover:text-teal-400">Shipping Policy</Link></li>
              <li><Link to="/refund" className="transition-colors hover:text-teal-400">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-6 border-t border-slate-800/50 pt-8 lg:flex-row">
          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex items-center gap-2 rounded-full border border-slate-800 bg-slate-900 px-4 py-2 text-xs font-bold uppercase tracking-wider">
              <SafeIcon icon={FiLock} className="text-teal-500" />
              256-Bit SSL Secure
            </div>
          </div>
          <p className="max-w-2xl text-center text-sm leading-relaxed text-slate-500 lg:text-right">
            All medical services are referral-based and provided through licensed healthcare professionals. © {new Date().getFullYear()} RenewRX. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}